<style scoped>

</style>
<style>
    /*.fin-report-table .fin-report-0-row td{
        background-color: #e5e5e5;
        font-weight: bold;
        color: #222;
    }
    .fin-report-table .fin-report-1-row td{
        background-color: #f5f5f5;
        color: #222;
    }*/
</style>
<template>
  <div>
    <Table
      ref="table"
      border
      class="fin-report-table"
      size="small"
      :height="table_height"
      :row-class-name="rowClassName"
      :no-data-text="no_data_text"
      :columns="table_columns"
      :data="table_rows"
      :loading="loading"
    />
    <div
      v-show="table_rows.length && false"
      class="line paginate-fix-bottom"
    >
      <Button
        type="primary"
        @click="exportCsv()"
      >
        导出CSV
      </Button>
    </div>
  </div>
</template>
<script route="/course_report/dashboard_monthly">
  import TermAlignPicker from './components/term_align_picker';
  export default {
    /* router_info_start */
    router_info: {
      path: '/course_report/dashboard_monthly',
      noChkout: true
    },
    components: { TermAlignPicker },
    /* router_info_end */
    props: ['type'],
    data() {
      return {
        params: {
          month: ''
        },
        loading: false,
        table_height: window.innerHeight - 140,
        courses: [],
        course_hash: [],
        course_data_types: [],
        course_data_types_hash: {},
        table_rows: [],
        type_data_hash: {},
        course_terms: []
      }
    },
    computed: {
      table_columns() {
        const columns = [
          {
            title: '费用类别',
            key: 'name',
            width: 170,
            fixed: 'left',
            align: 'center',
            renderHeader: (h, params) => {
              const ret = [
                h('DatePicker', {
                  attrs: {
                    style: 'width: 100px',
                    placeholder: '选择月份',
                  },
                  props: {
                    size: 'small',
                    type: 'month',
                    value: Util.curMonth(),
                    options: {
                      disabledDate(date) {
                        const now = new Date();
                        const disabledDateStart = new Date('2016-05-31').getTime();
                        let year = now.getFullYear();
                        let month = now.getMonth();
                        if (month === 11) {
                          year += 1;
                          month = 0;
                        } else {
                          month += 1;
                        }
                        const disabledDateEnd = new Date(`${year}-${month}-01`).getTime();
                        return date && (date.valueOf() < disabledDateStart || date.valueOf() > disabledDateEnd);
                      }
                    }
                  },
                  on: {
                    'on-change': (month) => {
                      this.params.month = month;
                      this.getReport();
                    }
                  }
                }),
                h('span', ' '),
                h('Button', {
                  props: {
                    size: 'small',
                    type: 'primary'
                  },
                  on: {
                    click: () => {
                      this.getReport();
                    }
                  }
                }, '确定')
              ];
              return h('div', {
                'class': {
                  'text-center': true
                }
              }, ret);
            },
            render: (h, params) => {
              const row = params.row;
              const ret = [];
              ret.push(h('span', `${row.name} `));
              if (row.name_tip) {
                ret.push(h('Tooltip', {
                  props: {
                    content: row.name_tip,
                    transfer: true,
                    placement: 'top'
                  }
                }, [
                  h('Icon', {
                    props: {
                      type: 'md-help-circle',
                      size: 12
                    }
                  })
                ]));
              }
              if (row.has_children) {
                const fold_text = row.fold ? '展开' : '收起';
                ret.push(h('span', {
                  'class': {
                    'color-info': row.fold,
                    'color-grey': !row.fold,
                    'pointer': true,
                    'float-right': true
                  },
                  on: {
                    click: () => {
                      const type = this.course_data_types_hash[row.id];
                      console.log(type);
                      type.fold = !type.fold;
                      this.genTableRows();
                    }
                  }
                }, fold_text));
              }
              return h('div', {
                'class': {
                  'text-left': true
                },
                style: {
                  paddingLeft: this.getPaddingLeft(row)
                }
              }, ret);
            }
          }
        ];
        let term_count = 0;
        this.course_terms.forEach((course_term_hash) => {
          term_count += course_term_hash.terms.length;
        });
        const column_width = term_count > 5 ? 120 : 150;
        this.course_terms.forEach((course_term_hash) => {
          const course = this.course_hash[course_term_hash.course_id];
          const course_column = {
            title: course.name,
            align: 'center',
            children: []
          };
          course_term_hash.terms.forEach((term) => {
            course_column.children.push({
              title: course.name,
              key: course.id,
              width: column_width,
              align: 'center',
              renderHeader: (h, params) => {
                return h('span', `第 ${term} 期`);
              },
              render: (h, params) => {
                const row = params.row;
                const type_data = this.type_data_hash[row.id];
                const course_term_key = `c${course.id}t${term}`;
                let value_obj = type_data[course_term_key];
                value_obj = value_obj ? value_obj : {number_value: 0, string_value: ''};
                let value = '';
                if (row.data_type === 'string') {
                  value = value_obj.string_value;
                  if (!value) {
                    value = '-';
                  }
                } else {
                  value = value_obj.number_value;
                  if (!value || value === '0.0') {
                    value = '-';
                  } else if (row.data_type === 'decimal') {
                    value = Util.formatDecimal(value);
                  } else if (row.data_type === 'int') {
                    value = Util.formatNumber(value);
                  } else if (row.data_type === 'percent') {
                    value = `${Util.formatDecimal(value)}%`;
                  }
                }
                return h('div', value);
              }
            });
          });

          columns.push(course_column);
        });
        return columns;
      },
      no_data_text() {
        if (this.table_rows.length || this.loading) {
          return '加载数据中...';
        } else {
          return '暂无数据';
        }
      }
    },
    created() {
      this.getCourses();
      this.getCourseDataTypes();
      this.init();
    },
    mounted() {
      //
    },
    methods: {
      init() {
        this.params.month = Util.curMonth();
        this.getReport();
      },
      getCourses() {
        Util.ajax.get(Util.api.get_courses, {
          //
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            this.courses = data.courses;
            this.courses.forEach((course) => {
              this.course_hash[course.id] = course;
            });
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          console.log(e);
        });
      },
      getCourseDataTypes() {
        Util.ajax.get(Util.api.get_course_data_types, {
          //
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const course_data_types = res.data.course_data_types;
            this.genCourseDataTypes(course_data_types);
            this.genTableRows();
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          console.log(e);
        });
      },
      genCourseDataTypes(course_data_types) {
        course_data_types.forEach((cdt) => {
          if (!cdt.is_hide) {
            cdt.has_children = cdt.course_data_types.length > 0;
            cdt.show = true;
            cdt.empty = false;
            this.course_data_types.push(cdt);
            this.course_data_types_hash[cdt.id] = cdt;
            if (cdt.has_children) {
              this.genCourseDataTypes(cdt.course_data_types);
            }
          }
        });
      },
      genTableRows() {
        this.table_rows = [];
        if (!this.course_data_types.length || !Object.keys(this.type_data_hash).length) {
          return;
        }
        this.course_data_types.forEach((type) => {
          const parent_type = this.course_data_types_hash[type.parent_id];
          if (parent_type && (parent_type.fold || !parent_type.show)) {
            type.show = false;
          } else {
            type.show = true;
            //let type_data = {title: type.name, level: type.level, data_type: type.data_type};
            const type_data = type;
            const show_data = this.type_data_hash[type.id];
            if (show_data) {
              //Object.assign(type_data, show_data);
              type_data.empty = false;
            } else {
              type_data.empty = true;
            }
            this.table_rows.push(type_data);
          }
        });
      },
      getReport() {
        if (this.loading) {
          return;
        }
        if (!this.params.month) {
          this.$Message.error('请选择月份');
          return;
        }
        this.table_rows = [];
        this.type_data_hash = {};
        this.loading = true;
        Util.ajax.get(Util.api.course_month_data, {
          params: this.params
        }).then((response) => {
          return response.data;
        }).then((res) => {
          this.loading = false;
          if (res.code === 1) {
            const data = res.data;
            const type_datas = data.type_datas;
            this.course_terms = data.course_terms;
            this.genTableData(type_datas);
            this.genTableRows();
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            })
          }
        }).catch((e) => {
          this.loading = false;
          console.log(e);
          this.$Modal.error({
            title: '错误',
            content: e.message
          })
        });
      },
      genTableData(type_datas) {
        const hash = {};
        type_datas.forEach((type_data) => {
          hash[type_data.course_data_type_id] = type_data;
        });
        this.type_data_hash = hash;
      },
      calcRowTotal(row) {
        let total = '0';
        Object.keys(row).forEach((key) => {
          if (Util.isNumber(key)) {
            total = math.eval(`${total} + ${row[key]}`).toFixed(2);
          }
        });
        return total;
      },
      getExpenseTypeName(id) {
        const type = this.course_data_types_hash[id];
        if (type) {
          return type.name;
        } else {
          return '未识别费用类别';
        }
      },
      getCourseTerm(course_id) {
        if (this.course_terms.hasOwnProperty(course_id)) {
          return this.course_terms[course_id];
        } else {
          return '?';
        }
      },
      getPaddingLeft(row) {
        let val = 0;
        switch (row.level) {
        case 1:
          val = '8px';
          break;
        case 2:
          val = '16px';
          break;
        case 3:
          val = '24px';
          break;
        case 4:
          val = '32px';
          break;
        case 5:
          val = '40px';
          break;
        default:
          val = '0px';
          break;
        }
        return val;
      },
      rowClassName(row, index) {
        return `fin-report-${row.level}-row`;
      },
      exportCsv() {
        this.$refs.table.exportCsv({filename: `${this.params.month}-月报.csv`})
      }
    }
  }
</script>
